<template>
    <UDropdownMenu :items="invoiceMenuItems">
        <UButton
            data-cy="invoice-menu-items"
            variant="outline"
            color="neutral"
            icon="i-ph-dots-three-vertical"
        />
    </UDropdownMenu>
</template>

<script setup lang="ts">
import {computed} from 'vue'
import {DropdownMenuItem} from '@nuxt/ui'
import {useInvoiceCreator} from '@/invoice/invoice.service'

const {showProject, showDepartment, showDiscount} = useInvoiceCreator()

const invoiceMenuItems = computed<DropdownMenuItem[]>(() => {
    return [
        {
            label: 'Vis prosjektfelt',
            type: 'checkbox',
            checked: showProject.value,
            onUpdateChecked: (checked) => showProject.value = checked
        },
        {
            label: 'Vis avdelingsfelt',
            type: 'checkbox',
            checked: showDepartment.value,
            onUpdateChecked: (checked) => showDepartment.value = checked
        },
        {
            label: 'Vis rabattfelt',
            type: 'checkbox',
            checked: showDiscount.value,
            onUpdateChecked: (checked) => showDiscount.value = checked
        },
    ]
})

</script>

<style scoped>

</style>